import {
  takeEvery, put, call, select,
} from 'redux-saga/effects';
import { ActionTypes } from 'src/store/requests/app/actions';
import { requestSelectors } from 'src/store/requests/selectors';
import { getDefaultPlacementType } from 'src/store/crosstable/selectors';
import { getBuildType } from 'src/helpers';
import { BuildEnv } from 'src/typings/env';
import { getPlacementTypesByComplex } from 'src/api';
import { IPlacementType } from 'src/store/type-displayed-spinner/types';
import { IFrontConfigTypeEnum, ISubViewMappingEFloorType } from 'src/typings/table';
import { queryClient } from 'src/lib/queryClient';
import { QUERY_KEYS } from 'src/constants/queryKeys';
import { Actions } from './actions';
import { Actions as View2dActions } from '../view-2d/actions';
import { getComplexId } from '../app/selectors';

export function* setTypeDisplayedParams() {
  const complexId: number | null = yield select(getComplexId);
  const { data } = yield call(getPlacementTypesByComplex);

  queryClient.setQueryData([QUERY_KEYS.PLACEMENT_TYPES, complexId], data['hydra:member']);

  const buildType = getBuildType();
  const isCrossTable = buildType === BuildEnv.crossTable;
  const defaultLang: string|undefined = yield select(requestSelectors.app.getLang);
  const defaultPlacementType: string | null = yield select(getDefaultPlacementType);

  yield put(Actions.setListTypesSuccess(data['hydra:member']));
  if (defaultPlacementType) {
    const displaySpinnerType: IPlacementType = defaultLang ? data['hydra:member'].find((type: IPlacementType) => {
      return type.title[defaultLang] === defaultPlacementType;
    }) : data['hydra:member'][0];
    yield put(Actions.setTypeDisplayedSpinner(displaySpinnerType.frontConfig[isCrossTable ? IFrontConfigTypeEnum.adminPanel : IFrontConfigTypeEnum.website].views.filter((view) => view.isEnabled)[0].type));
  } else {
    const foundedType: IPlacementType = data['hydra:member'].find((item: IPlacementType) => {
      return !!item.frontConfig[isCrossTable ? IFrontConfigTypeEnum.adminPanel : IFrontConfigTypeEnum.website].views.length;
    });
    if (foundedType) {
      const { views } = foundedType.frontConfig[isCrossTable ? IFrontConfigTypeEnum.adminPanel : IFrontConfigTypeEnum.website];
      const activeSubViews = views.filter((view) => view.isEnabled && !!view?.subViews?.length)[0]?.subViews?.filter((subView) => subView.isEnabled);
      if (activeSubViews) {
        const subViewType = activeSubViews[0].type;
        yield put(View2dActions.setFloorItemType(ISubViewMappingEFloorType[subViewType]));
      }
      yield put(Actions.setTypeDisplayedSpinner(foundedType.frontConfig[isCrossTable ? IFrontConfigTypeEnum.adminPanel : IFrontConfigTypeEnum.website].views.filter((view) => view.isEnabled)[0]?.type));
    }
  }
}

export function* getTypeDisplayedWatchSaga() {
  yield takeEvery(ActionTypes.GET_APP_DATA_REQUEST_SUCCESS, setTypeDisplayedParams);
}
